import { LiveAnnouncer } from "@angular/cdk/a11y";
import { HttpClient } from "@angular/common/http";
import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Params, Router } from "@angular/router";
// import { ConsoleReporter } from "jasmine";
import { BoardResponseModel } from "src/app/model/BoardResponseModel";
import { LotteryResponseModel } from "src/app/model/LotteryResponseModel";
import { MasterService } from "src/app/services/master.service";
import { AbstractControl } from "@angular/forms";

@Component({
  selector: "app-new-secure-lottery-au",
  templateUrl: "./new-lottery-au.component.html",
  styleUrls: ["./new-lottery-au.component.scss"],
})
export class NewLotteryAuComponent implements OnInit {
  lotteryKey: number;
  pageMode: string;
  lotteryResponseModel: LotteryResponseModel;
  form: FormGroup = new FormGroup({});
  isSubmitDisabled: boolean = false;
  boardsList: { [key: number]: string };
  stageList: string[];
  lotteryStage: string[];
  paymentGatewayList: string[];
  postLotteryType: string[];
  isLoading = false;
  nonEditable: boolean = false;
  nonEditables: boolean = false;
  showDraftList: boolean = false;
  showFinalList: boolean = false;
  showLoiBtn: boolean = false;
  showGenerateDrawResultBtn: boolean = false;
  showPolBtn: boolean = false;
  type: string;
  extendDayOfLoi: any;
  financialYears: { [key: number]: string };

  constructor(
    // @Inject(MAT_DIALOG_DATA) public data: any,
    // private boardService: MasterService,
    private masterService: MasterService,
    private _snackBar: MatSnackBar,
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private _formBuilder: FormBuilder
  ) {}

  ngOnInit() {
    console.log("Lottery component on init called");
    this.route.params.subscribe((params: Params) => {
      this.lotteryKey = +params["key"];
      this.type = params["type"];

      this.masterService
        .initNewLotteryForm(this.lotteryKey)
        .subscribe((data: any) => {
          this.isLoading = true;
          if (data.status === "SUCCESS") {
            this.boardsList = data.boards;
            this.stageList = data.stages;
            this.paymentGatewayList = data.paymentGateways;
            this.postLotteryType = data.postLotteryType;
            this.nonEditable = data.nonEditable;
            console.log(this.paymentGatewayList);
            this.financialYears = data.financialYears;
            this.isLoading = false;
            if (this.lotteryKey) {
              console.log("Lottery key get for edit " + this.lotteryKey);
              this.masterService
                .getLotteryBykey(this.lotteryKey)
                .subscribe((data: any) => {
                  this.lotteryResponseModel = data;
                  this.nonEditables = data.nonEditable;
                  this.pageMode = "Edit";
                  console.log("form mode Edit ******", data);

                  this.showDraftList =
                    this.lotteryResponseModel.lotteryStage ==
                    "PRE_LOTTERY_SCRUTINY"
                      ? true
                      : false;
                  this.showFinalList =
                    this.lotteryResponseModel.lotteryStage ==
                      "PRE_LOTTERY_SCRUTINY" &&
                    this.lotteryResponseModel.draftPublishApplication == "Y"
                      ? true
                      : false;
                  this.showLoiBtn =
                    this.lotteryResponseModel.lotteryStage == "POST_LOTTERY" &&
                    this.lotteryResponseModel.finalPublishApplication == "Y"
                      ? true
                      : false;
                  this.showGenerateDrawResultBtn =
                    this.lotteryResponseModel.lotteryStage == "POST_LOTTERY"
                      ? true
                      : false;
                  this.showPolBtn =
                    this.lotteryResponseModel.lotteryStage == "POST_LOTTERY"
                      ? true
                      : false;

                  console.log(data, "......................> From Data");
                  //TODO set board as key value pair

                  let selFinYears = [];
                  if(this.lotteryResponseModel.allowedFinancialYears) {
                    let allwedFinArray = this.lotteryResponseModel.allowedFinancialYears.split(",");
                    for(let finKey of allwedFinArray) {
                      if(this.financialYears[finKey]) {
                        selFinYears.push({ key: finKey, value:this.financialYears[finKey] });  
                      }
                    }
                  }

                  this.form.setValue({
                    lotteryCode: this.lotteryResponseModel.lotteryCode,
                    lotteryName: this.lotteryResponseModel.lotteryName,
                    applicationFee: this.lotteryResponseModel.applicationFee,
                     emdAmount: this.lotteryResponseModel.emdAmount,
                    lotteryStage: this.lotteryResponseModel.lotteryStage,
                    draftPublishApplication:
                      this.lotteryResponseModel.draftPublishApplication == "Y"
                        ? true
                        : false,
                    finalPublishApplication:
                      this.lotteryResponseModel.finalPublishApplication == "Y"
                        ? true
                        : false,
                    publishResult:
                      this.lotteryResponseModel.publishResult == "Y"
                        ? true
                        : false,
                    publishIntimationLetter:
                      this.lotteryResponseModel.publishIntimationLetter == "Y"
                        ? true
                        : false,
                    displaySequence: this.lotteryResponseModel.displaySequence,
                    applicationStartDate:
                      this.lotteryResponseModel.applicationStartDate,
                    applicationEndDate:
                      this.lotteryResponseModel.applicationEndDate,
                    onlinePaymentStartDate:
                      this.lotteryResponseModel.onlinePaymentStartDate,
                    onlinePaymentEndDate:
                      this.lotteryResponseModel.onlinePaymentEndDate,
                    rtgsNeftEndDate: this.lotteryResponseModel.rtgsNeftEndDate,
                    onlinePaymentEndDateUpdate:
                      this.lotteryResponseModel.onlinePaymentEndDateUpdate,
                    draftPublishApplicationDate:
                      this.lotteryResponseModel.draftPublishApplicationDate,
                    finalPublishApplicationDate:
                      this.lotteryResponseModel.finalPublishApplicationDate,
                    lotteryRunDate: this.lotteryResponseModel.lotteryRunDate,
                    refundStartDate: this.lotteryResponseModel.refundStartDate,
                    accaptanceStartDate:
                      this.lotteryResponseModel.accaptanceStartDate,
                    accaptanceEndDate:
                      this.lotteryResponseModel.accaptanceEndDate,
                    surrenderStartDate:
                      this.lotteryResponseModel.surrenderStartDate,
                    surrenderEndDate:
                      this.lotteryResponseModel.surrenderEndDate,
                    paymentGateway:
                      this.lotteryResponseModel.paymentGateway.split("#"),
                    bankVerification:
                      this.lotteryResponseModel.bankVerification,
                    pincodeWiseAllow:
                      this.lotteryResponseModel.pincodeWiseAllow == "Y"
                        ? true
                        : false,
                    allowedFinancialYears: 
                      this.lotteryResponseModel.allowedFinancialYears != null
                      ? selFinYears : null,
                    insPaymentGateway:
                      this.lotteryResponseModel.insPaymentGateway,
                    isNocPayment:
                      this.lotteryResponseModel.isNocPayment == "Y"
                        ? true
                        : false,
                    publishPOLLetter:
                      this.lotteryResponseModel.publishPOLLetter == "Y"
                        ? true
                        : false,
                    extendDayOfLoi: this.lotteryResponseModel.extendDayOfLoi,
                    minTenCostForTds:
                      this.lotteryResponseModel.minTenCostForTds,
                    tds: this.lotteryResponseModel.tds,
                    tdsUploadEndDays:
                      this.lotteryResponseModel.tdsUploadEndDays,
                    postLotteryType: this.lotteryResponseModel.postLotteryType,
                    nocPaymentGateway:
                      this.lotteryResponseModel.nocPaymentGateway,

                    boardKey: {
                      key: this.lotteryResponseModel.boardKey,
                      value: this.lotteryResponseModel.boardCodeName,
                    },
                    stageList: this.lotteryResponseModel.lotteryStage,
                    paymentGatewayList:
                      this.lotteryResponseModel.paymentGateway,
                  });

                  // Subscribe to value changes of isNocPayment control
                  this.form
                    .get("isNocPayment")
                    ?.valueChanges.subscribe((value) => {
                      if (value) {
                        // If isNocPayment is true, add the custom validator to nocPaymentGateway
                        this.form
                          .get("nocPaymentGateway")
                          ?.setValidators(this.getNocPaymentGatewayValidator());
                      } else {
                        // If isNocPayment is false, remove all validators from nocPaymentGateway
                        this.form.get("nocPaymentGateway")?.clearValidators();
                      }
                      // Update validity of the nocPaymentGateway control after modifying validators
                      this.form
                        .get("nocPaymentGateway")
                        ?.updateValueAndValidity();
                    });
                });
            } else {
              this.pageMode = "Add";
              console.log("form mode add");
            }
          } else {
            //toast data.errorMessage
          }
        });

      this.form = new FormGroup({
        lotteryCode: new FormControl(
          { value: null, disabled: this.lotteryKey > 0 ? true : false },
          Validators.required
        ),
        lotteryName: new FormControl(
          { value: null, disabled: this.lotteryKey > 0 ? true : false },
          Validators.required
        ),
        applicationFee: new FormControl(
          { value: null, disabled: this.lotteryKey > 0 ? true : false },
          Validators.required
        ),

       emdAmount: new FormControl(
        {value: null, disabled: this.lotteryKey > 0 ? true : false},
         Validators.required
        ),
        
        lotteryStage: new FormControl(null, Validators.required),
        draftPublishApplication: new FormControl(null),
        finalPublishApplication: new FormControl(null),
        publishResult: new FormControl({ disable: true }),
        publishIntimationLetter: new FormControl(null),
        displaySequence: new FormControl(
          { value: null, disabled: this.lotteryKey > 0 ? true : false },
          Validators.required
        ),
        applicationStartDate: new FormControl(null, Validators.required),
        applicationEndDate: new FormControl(null, Validators.required),
        onlinePaymentStartDate: new FormControl(null, Validators.required),
        onlinePaymentEndDate: new FormControl(null, Validators.required),
        rtgsNeftEndDate: new FormControl(null, Validators.required),
        onlinePaymentEndDateUpdate: new FormControl(null, Validators.required),
        draftPublishApplicationDate: new FormControl(null, Validators.required),
        finalPublishApplicationDate: new FormControl(null, Validators.required),
        lotteryRunDate: new FormControl(null, Validators.required),
        refundStartDate: new FormControl(null, Validators.required),
        accaptanceStartDate: new FormControl(null, Validators.required),
        accaptanceEndDate: new FormControl(null, Validators.required),
        surrenderStartDate: new FormControl(null, Validators.required),
        surrenderEndDate: new FormControl(null, Validators.required),
        paymentGateway: new FormControl(null, Validators.required),
        allowedFinancialYears: new FormControl(null, Validators.required),
        bankVerification: new FormControl(null, Validators.required),
        publishPOLLetter: new FormControl(null),
        pincodeWiseAllow: new FormControl(null),
        isNocPayment: new FormControl(null),
        insPaymentGateway: new FormControl(null, Validators.required),
        extendDayOfLoi: new FormControl(null, Validators.required),
        minTenCostForTds: new FormControl(null, Validators.required),
        tds: new FormControl(null, Validators.required),
        tdsUploadEndDays: new FormControl(null, Validators.required),
        postLotteryType: new FormControl(null, Validators.required),
        nocPaymentGateway: new FormControl(null),

        boardKey: new FormControl(
          { value: null, disabled: this.lotteryKey > 0 ? true : false },
          Validators.required
        ),
        stageList: new FormControl(null, Validators.required),
        paymentGatewayList: new FormControl(null, Validators.required),
      });

      this.form
        .get("accaptanceStartDate")
        .setValidators(this.getAccaptanceStartDateValidator());
      this.form
        .get("accaptanceEndDate")
        .setValidators(this.getAccaptanceEndDateValidator());

      this.form
        .get("surrenderStartDate")
        .setValidators(this.getSurrenderStartDateValidator());
      this.form
        .get("surrenderEndDate")
        .setValidators(this.getSurrenderEndDateValidator());

      this.form
        .get("postLotteryType")
        .setValidators(this.getPostLotteryTypeValidator());
      this.form
        .get("insPaymentGateway")
        .setValidators(this.getInsPaymentGatewayValidator());

      this.form
        .get("extendDayOfLoi")
        .setValidators(this.getExtendDayOfLoiValidator());

      this.form
        .get("minTenCostForTds")
        .setValidators(this.getMinTenCostForTdsValidator());
      this.form.get("tds").setValidators(this.getTdsValidator());

      this.form
        .get("tdsUploadEndDays")
        .setValidators(this.getTdsUploadEndDaysValidator());
    });
  }

  private getAccaptanceStartDateValidator() {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      // Check if lotteryStage is 'POST_LOTTERY'
      if (this.form.get("lotteryStage").value === "POST_LOTTERY") {
        // If lotteryStage is 'POST_LOTTERY', make accaptanceEndDate required
        return Validators.required(control);
      }
      return null; // No validation error
    };
  }

  private getAccaptanceEndDateValidator() {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (this.form.get("lotteryStage").value === "POST_LOTTERY") {
        return Validators.required(control);
      }
      return null;
    };
  }

  private getSurrenderStartDateValidator() {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (this.form.get("lotteryStage").value === "POST_LOTTERY") {
        return Validators.required(control);
      }
      return null;
    };
  }

  private getSurrenderEndDateValidator() {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (this.form.get("lotteryStage").value === "POST_LOTTERY") {
        return Validators.required(control);
      }
      return null;
    };
  }

  private getPostLotteryTypeValidator() {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (this.form.get("lotteryStage").value === "POST_LOTTERY") {
        return Validators.required(control);
      }
      return null;
    };
  }

  private getInsPaymentGatewayValidator() {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (this.form.get("lotteryStage").value === "POST_LOTTERY") {
        return Validators.required(control);
      }
      return null;
    };
  }

  private getNocPaymentGatewayValidator() {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (
        this.form.get("lotteryStage").value === "POST_LOTTERY" &&
        this.form.get("isNocPayment").value === true
      ) {
        return Validators.required(control);
      }
      return null;
    };
  }

  private getExtendDayOfLoiValidator() {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (this.form.get("lotteryStage").value === "POST_LOTTERY") {
        return Validators.required(control);
      }
      return null;
    };
  }

  private getMinTenCostForTdsValidator() {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (this.form.get("lotteryStage").value === "POST_LOTTERY") {
        return Validators.required(control);
      }
      return null;
    };
  }
  private getTdsValidator() {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (this.form.get("lotteryStage").value === "POST_LOTTERY") {
        return Validators.required(control);
      }
      return null;
    };
  }

  private getTdsUploadEndDaysValidator() {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (this.form.get("lotteryStage").value === "POST_LOTTERY") {
        return Validators.required(control);
      }
      return null;
    };
  }

  // onFileSelect(event) {
  //   this.boardLogoFile = event.target.files[0];
  // }

  onCheckboxChangeDraftPublish(e: any) {
    if (e.target) {
      console.log("check box ticked");
    }
  }

  onCheckboxPinCodeWiseAllow(e: any) {
    if (e.target) {
      console.log("check box ticked");
    }
  }
  onCheckboxChangeFinalPublish(e: any) {
    if (e.target) {
      console.log("check box ticked");
    }
  }
  onCheckboxChangeResult(e: any) {
    if (e.target) {
      console.log("check box ticked");
    }
  }

  onSubmit() {
    if (this.pageMode === "Add") {
      console.log("going to save");
      this.saveLottery();
    } else {
      console.log("going to update");
      this.updateBoard();
    }
  }

  async saveLottery() {
    console.log("in save Lottery");
    // console.log(this.form.value.draftPublishApplicationDate);
    // if (this.form.valid) {
    console.log("in save Lottery form vaideated");
    console.log(this.form.value.bankVerification);
    //      let text = this.form.value.paymentGateway.toString().replaceAll(",", "#");

    if (!this.validateApplicationStartDate()) {
      this.masterService.errorToast(
        "Application Start Date should be greater than or equal Current Date"
      );
      this.isSubmitDisabled = false;
      return;
    }

    if (!this.validateApplicationFee()) {
      this.masterService.errorToast("Application Fee should be greater than 0");
      this.isSubmitDisabled = false;
      return;
    }

    if(!this.validateEMDAmount()){
        this.masterService.errorToast("EMD Amount should be greater than 0");
        this.isSubmitDisabled = false;
        return;
      }

    if (!this.validateDisplaySeq()) {
      this.masterService.errorToast("Display Seq should be greater than 0");
      this.isSubmitDisabled = false;
      return;
    }

    if (!this.validateApplicationEndDate()) {
      this.masterService.errorToast(
        "Application End Date should be greater than Application Start Date"
      );
      this.isSubmitDisabled = false;
      return;
    }

    if (!this.validateOnlinePaymentStartDate()) {
      this.masterService.errorToast(
        "Online Payment Start Date should be greater than Application Start Date"
      );
      this.isSubmitDisabled = false;
      return;
    }

    if (!this.validateOnlinePaymentEndDate()) {
      this.masterService.errorToast(
        "Online Payment End Date should be greater than or Equal Online Payment Start Date"
      );
      this.isSubmitDisabled = false;
      return;
    }

    if (!this.validateRtgsNeftEndDate()) {
      this.masterService.errorToast(
        "RTGS - NEFT Payment Date should be greater than Online Payment Start Date"
      );
      this.isSubmitDisabled = false;
      return;
    }

    if (!this.validateOnlinePaymentEndDateUpdate()) {
      this.masterService.errorToast(
        "Online Payment End Date Update should be greater than or Equal Online Payment End Date"
      );
      this.isSubmitDisabled = false;
      return;
    }

    if (!this.validateDraftPublishApplicationDate()) {
      this.masterService.errorToast(
        "Draft Publish Application Date should be greater than Online Payment End Date And Rtgs Payment Last date "
      );
      this.isSubmitDisabled = false;
      return;
    }

    if (!this.validateFinalPublishApplicationDate()) {
      this.masterService.errorToast(
        "Final Publish Application Date should be greater than Draft Publish Application Date"
      );
      this.isSubmitDisabled = false;
      return;
    }

    if (!this.validateLotteryRunDate()) {
      this.masterService.errorToast(
        "Lottery Run Date should be greater than Final Publish Application Date"
      );
      this.isSubmitDisabled = false;
      return;
    }

    if (!this.validateRefundStartDate()) {
      this.masterService.errorToast(
        "Refund Start Date should be greater than Lottery Run Date"
      );
      this.isSubmitDisabled = false;
      return;
    }

    console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>" + this.form.value);
    this.masterService
      .saveNewLottery({
        lotteryCode: this.form.value.lotteryCode,
        lotteryName: this.form.value.lotteryName,
        activeFlag: this.form.value.activeFlag,
        applicationFee: this.form.value.applicationFee,
        emdAmount: this.form.value.emdAmount,
        lotteryStage: this.form.value.lotteryStage,
        draftPublishApplication: this.form.value.draftPublishApplication,
        finalPublishApplication: this.form.value.finalPublishApplication,
        publishResult: this.form.value.publishResult,
        publishIntimationLetter: this.form.value.publishIntimationLetter,
        displaySequence: this.form.value.displaySequence,
        boardKey: this.form.value.boardKey?.key,
        applicationStartDate: this.form.value.applicationStartDate,
        applicationEndDate: this.form.value.applicationEndDate,
        onlinePaymentStartDate: this.form.value.onlinePaymentStartDate,
        onlinePaymentEndDate: this.form.value.onlinePaymentEndDate,
        rtgsNeftEndDate: this.form.value.rtgsNeftEndDate,
        onlinePaymentEndDateUpdate: this.form.value.onlinePaymentEndDateUpdate,
        draftPublishApplicationDate:
          this.form.value.draftPublishApplicationDate,
        finalPublishApplicationDate:
          this.form.value.finalPublishApplicationDate,
        lotteryRunDate: this.form.value.lotteryRunDate,
        refundStartDate: this.form.value.refundStartDate,
        accaptanceStartDate: this.form.value.accaptanceStartDate,
        accaptanceEndDate: this.form.value.accaptanceEndDate,
        surrenderStartDate: this.form.value.surrenderStartDate,
        surrenderEndDate: this.form.value.surrenderEndDate,
        paymentGateway: this.form.value.paymentGateway
          .toString()
          .replaceAll(",", "#"),
        allowedFinancialYears: this.form.value.allowedFinancialYears.map(af => af.key).join(","),
        bankVerification: this.form.value.bankVerification,
        publishPOLLetter: this.form.value.publishPOLLetter,
        pincodeWiseAllow: this.form.value.pincodeWiseAllow,
        insPaymentGateway: this.form.value.insPaymentGateway,
        isNocPayment: this.form.value.isNocPayment,
        extendDayOfLoi: this.form.value.extendDayOfLoi,
        minTenCostForTds: this.form.value.minTenCostForTds,
        tds: this.form.value.tds,
        tdsUploadEndDays: this.form.value.tdsUploadEndDays,
        postLotteryType: this.form.value.postLotteryType,
        nocPaymentGateway: this.form.value.nocPaymentGateway,
      })
      .subscribe(
        (data: any) => {
          if (data.status === "SUCCESS") {
            this.successToast();
            this.router.navigate(["/secure", "master", "new-lottery", "list"]);
          } else {
            this.isSubmitDisabled = false;
            this.errorToast(data.errorMessage);
          }
        },
        (error) => {
          this.isSubmitDisabled = false;
          console.log(error);
          this.errorToast(error.error.errorMessage, 5 * 1000);
        }
      );
    // };
  }

  async updateBoard() {
    console.log(this.form.value);
    console.log(this.form);

    if (this.form.valid) {
      if (!this.validateApplicationEndDate()) {
        this.masterService.errorToast(
          "Application End Date should be greater than Application Start Date"
        );
        this.isSubmitDisabled = false;
        return;
      }

      if (!this.validateOnlinePaymentStartDate()) {
        this.masterService.errorToast(
          "Online Payment Start Date should be greater than Application Start Date"
        );
        this.isSubmitDisabled = false;
        return;
      }

      if (!this.validateOnlinePaymentEndDate()) {
        this.masterService.errorToast(
          "Online Payment End Date should be greater than or Equal Online Payment Start Date"
        );
        this.isSubmitDisabled = false;
        return;
      }

      if (!this.validateRtgsNeftEndDate()) {
        this.masterService.errorToast(
          "Rtgs Neft Payment Date should be greater than Online Payment Start Date"
        );
        this.isSubmitDisabled = false;
        return;
      }

      if (!this.validateOnlinePaymentEndDateUpdate()) {
        this.masterService.errorToast(
          "Online Payment End Date Update should be greater than or Equal Online Payment End Date"
        );
        this.isSubmitDisabled = false;
        return;
      }

      if (!this.validateDraftPublishApplicationDate()) {
        this.masterService.errorToast(
          "Draft Publish Application Date should be greater than Online Payment End Date And Rtgs Payment Last date "
        );
        this.isSubmitDisabled = false;
        return;
      }

      if (!this.validateFinalPublishApplicationDate()) {
        this.masterService.errorToast(
          "Final Publish Application Date should be greater than Draft Publish Application Date"
        );
        this.isSubmitDisabled = false;
        return;
      }

      if (!this.validateLotteryRunDate()) {
        this.masterService.errorToast(
          "Lottery Run Date should be greater than Final Publish Application Date"
        );
        this.isSubmitDisabled = false;
        return;
      }

      if (!this.validateRefundStartDate()) {
        this.masterService.errorToast(
          "Refund Start Date should be greater than Lottery Run Date"
        );
        this.isSubmitDisabled = false;
        return;
      }

      if (!this.validateAcceptanceTenementEndDate() && this.lotteryStages()) {
        this.masterService.errorToast(
          "Acceptance End Date should be greater than Acceptance Start Date "
        );
        this.isSubmitDisabled = false;
        return;
      }

      if (!this.validateSurrenderTenementEndDate() && this.lotteryStages()) {
        this.masterService.errorToast(
          "Surrender  End Date should be greater than Surrender Start Date "
        );
        this.isSubmitDisabled = false;
        return;
      }

      console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>" + this.form.value);

      this.masterService
        .updateNewLottery(this.lotteryKey, {
          lotteryCode: this.lotteryResponseModel.lotteryCode,
          lotteryName: this.lotteryResponseModel.lotteryName,
          activeFlag: this.lotteryResponseModel.activeFlag,
          applicationFee: this.lotteryResponseModel.applicationFee,
          emdAmount:  this.lotteryResponseModel.emdAmount,
          lotteryStage: this.form.value.lotteryStage,
          draftPublishApplication: this.form.value.draftPublishApplication,
          finalPublishApplication: this.form.value.finalPublishApplication,
          publishResult: this.form.value.publishResult,
          publishIntimationLetter: this.form.value.publishIntimationLetter,
          displaySequence: this.lotteryResponseModel.displaySequence,
          boardKey: this.lotteryResponseModel.boardKey,
          applicationStartDate: this.form.value.applicationStartDate,
          applicationEndDate: this.form.value.applicationEndDate,
          onlinePaymentStartDate: this.form.value.onlinePaymentStartDate,
          onlinePaymentEndDate: this.form.value.onlinePaymentEndDate,
          rtgsNeftEndDate: this.form.value.rtgsNeftEndDate,
          onlinePaymentEndDateUpdate: this.form.value.onlinePaymentEndDate,
          draftPublishApplicationDate:
            this.form.value.draftPublishApplicationDate,
          finalPublishApplicationDate:
            this.form.value.finalPublishApplicationDate,
          lotteryRunDate: this.form.value.lotteryRunDate,
          refundStartDate: this.form.value.refundStartDate,
          accaptanceStartDate: this.form.value.accaptanceStartDate,
          accaptanceEndDate: this.form.value.accaptanceEndDate,
          surrenderStartDate: this.form.value.surrenderStartDate,
          surrenderEndDate: this.form.value.surrenderEndDate,
          paymentGateway: this.form.value.paymentGateway
            .toString()
            .replaceAll(",", "#"),
          bankVerification: this.form.value.bankVerification,
          publishPOLLetter: this.form.value.publishPOLLetter,
          pincodeWiseAllow: this.form.value.pincodeWiseAllow,
          insPaymentGateway: this.form.value.insPaymentGateway,
          isNocPayment: this.form.value.isNocPayment,
          extendDayOfLoi: this.form.value.extendDayOfLoi,
          minTenCostForTds: this.form.value.minTenCostForTds,
          tds: this.form.value.tds,
          tdsUploadEndDays: this.form.value.tdsUploadEndDays,
          postLotteryType: this.form.value.postLotteryType,
          nocPaymentGateway: this.form.value.nocPaymentGateway,
          allowedFinancialYears: this.form.value.allowedFinancialYears.map(af => af.key).join(","),
        })
        .subscribe(
          (data: any) => {
            this.isLoading = true;
            if (data.status === "SUCCESS") {
              this.isLoading = false;
              this.successToast();
              this.router.navigate([
                "/secure",
                "master",
                "new-lottery",
                "list",
              ]);
            } else {
              this.isSubmitDisabled = false;
              this.errorToast(data.errorMessage);
              this.isLoading = false;
            }
          },
          (error) => {
            this.isSubmitDisabled = false;
            console.log(error);
            this.errorToast(error.error.errorMessage, 5 * 1000);
          }
        );
    } else {
      this.isSubmitDisabled = false;
      this.errorToast("Please enter valid data for all fields.");
    }
  }

  validateApplicationStartDate() {
    return new Date(this.form.value.applicationStartDate) >= new Date()
      ? true
      : false;
  }

  validateDisplaySeq() {
    return this.form.value.displaySequence > 0 ? true : false;
  }

  validateApplicationFee() {
    return this.form.value.applicationFee > 0 ? true : false;
  }

  validateEMDAmount(){
    return this.form.value.emdAmount > 0 ? true : false;
  }

  validateApplicationEndDate() {
    return new Date(this.form.value.applicationStartDate) <
      new Date(this.form.value.applicationEndDate)
      ? true
      : false;
  }

  validateOnlinePaymentStartDate() {
    return new Date(this.form.value.applicationStartDate) <=
      new Date(this.form.value.onlinePaymentStartDate)
      ? true
      : false;
  }
  validateOnlinePaymentEndDate() {
    return new Date(this.form.value.onlinePaymentStartDate) <
      new Date(this.form.value.onlinePaymentEndDate)
      ? true
      : false;
  }

  validateOnlinePaymentEndDateUpdate() {
    return new Date(this.form.value.onlinePaymentEndDate) <=
      new Date(this.form.value.onlinePaymentEndDateUpdate)
      ? true
      : false;
  }

  validateRtgsNeftEndDate() {
    return new Date(this.form.value.onlinePaymentStartDate) <
      new Date(this.form.value.rtgsNeftEndDate)
      ? true
      : false;
  }

  validateDraftPublishApplicationDate() {
    return new Date(this.form.value.onlinePaymentEndDateUpdate) <
      new Date(this.form.value.draftPublishApplicationDate) &&
      new Date(this.form.value.rtgsNeftEndDate) <
        new Date(this.form.value.draftPublishApplicationDate)
      ? true
      : false;
  }

  validateFinalPublishApplicationDate() {
    return new Date(this.form.value.draftPublishApplicationDate) <
      new Date(this.form.value.finalPublishApplicationDate)
      ? true
      : false;
  }

  validateLotteryRunDate() {
    return new Date(this.form.value.finalPublishApplicationDate) <
      new Date(this.form.value.lotteryRunDate)
      ? true
      : false;
  }

  validateRefundStartDate() {
    return new Date(this.form.value.lotteryRunDate) <
      new Date(this.form.value.refundStartDate)
      ? true
      : false;
  }

  validateAcceptanceTenementEndDate() {
    return new Date(this.form.value.accaptanceStartDate) <
      new Date(this.form.value.accaptanceEndDate)
      ? true
      : false;
  }

  validateSurrenderTenementEndDate() {
    return new Date(this.form.value.surrenderStartDate) <
      new Date(this.form.value.surrenderEndDate)
      ? true
      : false;
  }

  lotteryStages() {
    return this.form.get("lotteryStage").value === "POST_LOTTERY"
      ? true
      : false;
  }

  async successToast() {
    await this._snackBar.open("Lottery details saved successfully.", "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "success-toast",
      duration: 3 * 1000,
    });
  }

  async warningToast() {
    await this._snackBar.open("Please Upload Logo", "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "warning-toast",
      duration: 3 * 1000,
    });
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: dur ? dur : 3 * 1000,
    });
  }

  showBoard(o1: any, o2: any) {
    if (o1 && o2 && o1.key == o2.key) {
      return o1.value;
    } else {
      return "";
    }
  }

  showStage(o1: any, o2: any) {
    if (o1 && o2 && o1 == o2) {
      return o1;
    } else {
      return "";
    }
  }

  showPaymentGateway(o1: any, o2: any) {
    if (o1 && o2 && o1 == o2) {
      return o1;
    } else {
      return "";
    }
  }

  showFinancialYears(o1: any, o2: any) {
    if (o1 && o2 && o1.key == o2.key) {
      return o1.value;
    } else {
      return "";
    }
  }

  showinsPaymentGateway(o1: any, o2: any) {
    if (o1 && o2 && o1 == o2) {
      return o1;
    } else {
      return "";
    }
  }

  genereteDraftList(lstName: string) {
    console.log("Generete " + lstName + " List Call");
    console.log(this.lotteryResponseModel.boardKey);
    console.log(this.lotteryKey);

    this.isLoading = true;
    this.masterService
      .genereteDraftList(this.lotteryResponseModel.boardKey, this.lotteryKey)
      .subscribe(
        (data) => {
          this.isSubmitDisabled = false;
          this.isLoading = true;
          if (data.status === "SUCCESS") {
            this.masterService.successToast(
              lstName + " List generated Successfully."
            );
            this.isLoading = false;
          } else {
            this.errorToast(data.errorMessage);
            this.isLoading = false;
          }
        },
        (error) => {
          this.isLoading = false;
          this.isSubmitDisabled = false;
          this.errorToast(
            error?.error?.message ||
              error?.errorMessage ||
              error?.error?.errorMessage
          );
        }
      );
  }

  generateHashcodeReport() {
    this.isLoading = true;
    this.masterService.generateHashcodeReport(this.lotteryKey).subscribe(
      (data) => {
        this.isSubmitDisabled = false;
        this.isLoading = false;
        if (data.status === "SUCCESS") {
          this.downloadFile(data.base64File, data.fileName);
        } else {
          this.errorToast(data.errorMessage);
        }
      },
      (error) => {
        this.isLoading = false;
        this.isSubmitDisabled = false;
        this.errorToast(
          error?.error?.message ||
            error?.errorMessage ||
            error?.error?.errorMessage
        );
      }
    );
  }

  downloadFile(base64: string | ArrayBuffer, fileName: string) {
    const src = `${base64}`;
    const link = document.createElement("a");
    link.href = src;
    link.download = fileName;
    link.click();

    link.remove();
  }

  genereteBulkLoi() {
    console.log("Button Call");
    console.log(this.lotteryKey);

    this.masterService.generateBulkLoi(this.lotteryKey).subscribe(
      (data) => {
        if (data.status === "SUCCESS") {
          this.masterService.successToast(
            " Job for Bulk LOI Generation Started."
          );
        } else {
          this.errorToast(data.errorMessage);
        }
      },
      (error) => {
        this.errorToast(
          error?.error?.message ||
            error?.errorMessage ||
            error?.error?.errorMessage
        );
      }
    );
  }

  genereteBulkPOL() {
    console.log("Button Call");
    console.log(this.lotteryKey);

    this.masterService.generateBulkPOL(this.lotteryKey).subscribe(
      (data) => {
        if (data.status === "SUCCESS") {
          this.masterService.successToast(
            " Job for Bulk POL Generation Started."
          );
        } else {
          this.errorToast(data.errorMessage);
        }
      },
      (error) => {
        this.errorToast(
          error?.error?.message ||
            error?.errorMessage ||
            error?.error?.errorMessage
        );
      }
    );
  }

  generateDrawResult(lstName: string) {
    console.log("Generete " + lstName + " Draw Result Call");
    console.log(this.lotteryResponseModel.boardKey);
    console.log(this.lotteryKey);

    this.isLoading = true;
    this.masterService
      .generateDrawResult(this.lotteryResponseModel.boardKey, this.lotteryKey)
      .subscribe(
        (data) => {
          this.isSubmitDisabled = false;
          this.isLoading = true;
          if (data.status === "SUCCESS") {
            this.masterService.successToast(
              lstName + " Draw Result generated Successfully."
            );
            this.isLoading = false;
          } else {
            this.errorToast(data.errorMessage);
            this.isLoading = false;
          }
        },
        (error) => {
          this.isLoading = false;
          this.isSubmitDisabled = false;
          this.errorToast(
            error?.error?.message ||
              error?.errorMessage ||
              error?.error?.errorMessage
          );
        }
      );
  }

  // async saveCategory() {
  //   const response: any = this.boardService.saveCategory(this.catNameEng, this.catNameMar);
  //   console.log(response);
  //   if (!response.error) {
  //     if (response.length > 0) {
  //       this.successToast();
  //     } else {
  //       this.warningToast();
  //     }
  //   } else {
  //     this.errorToast();
  //   }
  // }

  // async successToast() {
  //   await this._snackBar.open("Category details saved successfully.", "Close", {
  //     horizontalPosition: "right",
  //     verticalPosition: "top",
  //     panelClass: "success-toast",
  //     duration: 3 * 1000,
  //   });
  // }

  // async warningToast() {
  //   await this._snackBar.open(
  //     "Something went wrong while saving category details, please try again after sometime.",
  //     "Close",
  //     {
  //       horizontalPosition: "right",
  //       verticalPosition: "top",
  //       panelClass: "warning-toast",
  //       duration: 3 * 1000,
  //     }
  //   );
  // }

  // async errorToast() {
  //   await this._snackBar.open("Oops, something went wrong, please try after sometime.", "Close", {
  //     horizontalPosition: "right",
  //     verticalPosition: "top",
  //     panelClass: "error-toast",
  //     duration: 3 * 1000,
  //   });
  // }

  onKeyPress(event: KeyboardEvent): void {
    // Allow only digits
    if (event.key < "0" || event.key > "9") {
      event.preventDefault();
    }
    // Allow only up to three digits
    const inputValue: string = (event.target as HTMLInputElement).value;
    if (inputValue.length >= 3) {
      event.preventDefault();
    }
  }

  // isNumberKey(event: KeyboardEvent): boolean {
  //   const key = event.key;
  //   // Allow digits (0-9) and the decimal point (.)
  //   if ((key >= '0' && key <= '9') || key === '.') {
  //     // Check if the input already contains a decimal point
  //     const inputValue: string = (event.target as HTMLInputElement).value;
  //     if (key === '.' && inputValue.includes('.')) {
  //       event.preventDefault();
  //       return false;
  //     }
  //     return true;
  //   }
  //   event.preventDefault();
  //   return false;
  // }

  validateNumericInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const inputValue = inputElement.value;
    // Replace non-numeric characters and multiple decimals
    const newValue = inputValue
      .replace(/[^0-9.]/g, "")
      .replace(/(\..*)\./g, "$1");

    // Update the input value
    if (newValue !== inputValue) {
      inputElement.value = newValue;
      this.form.get("tds").setValue(newValue); // Update form control value
      inputElement.dispatchEvent(new Event("input"));
    }
  }

  onCheck(e: any) {
    console.log("**************", this.form.get("isNocPayment").value);
    if (e.target.checked) {
      this.form.get("isNocPayment")?.setValue(true);
      this.lotteryResponseModel.isNocPayment = "Y";
    } else {
      this.form.get("isNocPayment")?.setValue(false);
      this.lotteryResponseModel.isNocPayment = "N";
    }
  }
}
